import React from "react";
import { Outlet } from "react-router-dom";
import PageNotFound from "./PageNotFound";

const PrivateComponent = () => {
  const auth = localStorage.getItem("user");
  return auth ? <Outlet /> : <PageNotFound/>;
};

export default PrivateComponent;
